import { Instagram, ArrowUpRight } from "lucide-react";
import { IMAGES, SOCIALS } from "../lib/data";

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-cream-alt overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="eyebrow mb-5">— The Spa Diary</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brown-dark leading-[1.05] tracking-tight">
              Fluffy faces, freshly <em className="italic text-lilac-dark">spa'd</em>.
            </h2>
          </div>
          <a
            href={SOCIALS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gallery-instagram-link"
            className="text-text-secondary md:max-w-sm hover:text-lilac-dark transition-colors flex items-start gap-2 group"
          >
            <span>
              Catch all the latest before &amp; afters over on Instagram —
              <span className="underline underline-offset-4 decoration-lilac-dark group-hover:text-lilac-dark">
                {" "}@barksandco.nz
              </span>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          <div className="gallery-img col-span-2 row-span-2 aspect-square md:aspect-auto" data-testid="gallery-image-0">
            <img src={IMAGES.gallery[0]} alt="Fluffy cavoodle with bow on grooming table" loading="lazy" />
          </div>
          <div className="gallery-img aspect-square" data-testid="gallery-image-1">
            <img src={IMAGES.gallery[1]} alt="Cavoodle sitting on studio floor" loading="lazy" />
          </div>
          <div className="gallery-img aspect-square" data-testid="gallery-image-2">
            <img src={IMAGES.gallery[2]} alt="Cavoodle being gently scissored on the face" loading="lazy" />
          </div>
          <div className="gallery-img aspect-square" data-testid="gallery-image-3">
            <img src={IMAGES.gallery[3]} alt="Cavalier King Charles being trimmed" loading="lazy" />
          </div>
          <div className="gallery-img aspect-[4/5]" data-testid="gallery-image-4">
            <img src={IMAGES.gallery[4]} alt="Chocolate Labrador puppy nail trim" loading="lazy" />
          </div>
          <div className="gallery-img aspect-[4/5]" data-testid="gallery-image-5">
            <img src={IMAGES.gallery[5]} alt="Pup paw pad trim with clippers" loading="lazy" />
          </div>
          <div className="gallery-img aspect-[4/5]" data-testid="gallery-image-6">
            <img src={IMAGES.gallery[6]} alt="Golden retriever being gently brushed" loading="lazy" />
          </div>

          {/* Instagram CTA tile */}
          <a
            href={SOCIALS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gallery-instagram-tile"
            className="col-span-2 aspect-[16/10] rounded-[2rem] bg-brown-dark text-cream p-8 md:p-10 flex flex-col justify-between hover:bg-[#3A291C] transition-all group overflow-hidden relative"
          >
            <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-lilac/20 group-hover:scale-125 transition-transform duration-700" />
            <div className="relative">
              <Instagram size={28} className="text-lilac" />
              <div
                className="eyebrow mt-5"
                style={{ color: "rgba(249, 246, 240, 0.7)" }}
              >
                Follow Along
              </div>
              <h3 className="font-serif text-3xl md:text-4xl mt-2 leading-tight">
                See every fresh trim &amp; happy face on Instagram.
              </h3>
            </div>
            <div className="relative flex items-center gap-2 font-medium">
              @barksandco.nz
              <ArrowUpRight
                size={18}
                className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
              />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
